/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Impersonation_BannerInputs */



/**
* | output |
* | --- |
* | "You are viewing Wundo as {name}. Anything you do here happens on that account." |
*
* @param {Impersonation_BannerInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const impersonation_banner = /** @type {((inputs: Impersonation_BannerInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impersonation_BannerInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Je bekijkt Wundo als ${i?.name}. Wat je hier doet, gebeurt op dat account.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Vous consultez Wundo en tant que ${i?.name}. Ce que vous faites ici se passe sur ce compte.`)
	return /** @type {LocalizedString} */ (`You are viewing Wundo as ${i?.name}. Anything you do here happens on that account.`)
});